export const VAULT_CONTRACT_ADDRESS = '0xb21b972B2aA69a01C6f7e6C19717126C7cD7559F';
